import { Button } from '@mui/material'
import React from 'react'

const SubmitTypeButton = (props:any) => <Button {...props}  type="submit" /> 

export default SubmitTypeButton